/**
 * Create Addresses context for custom hook
 */

import { createContext } from 'react'

const AddressesContext = createContext({
  fetchCountries: () => {},
  fetchStatesCitiesDistricts: () => {},
  fetchStreet: () => {},
  fetchZip: () => {}
})

export default AddressesContext
